module.exports = __webpack_public_path__ + "static/astarion_mtg_clb-d6281f404c34feeb1e834cd29c611c03.jpg";